import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { Collapse, Column, Grid, GridItem, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import DiscountInput from "../../ServiceBuilder/DiscountInput";
import MinPriceTextField from "../../ServiceBuilder/MinPriceTextField";
import PriceTextField from "../../ServiceBuilder/PriceTextField";
import PricingTextField from "../../ServiceBuilder/PricingTextField";
import { getPriceAfterDiscount } from "../../ServiceBuilder/ServiceBuilder.utils";
import UnitNameTextField from "../../ServiceBuilder/UnitNameTextField";
import styles from "./ServicePriceEditorPopoverPricingContent.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getServicePriceEditorPopoverPricingContentTID = () => getTestIds();
const ServicePriceEditorPopoverPricingContent = _ref => {
  let {
    serviceOrigin
  } = _ref;
  const {
    ServicePriceEditorPopoverPricingContentTID
  } = useMemo(() => getServicePriceEditorPopoverPricingContentTID(), []);
  const {
    watch,
    formState
  } = useFormContext();
  const {
    pricing,
    price,
    minPrice,
    discount,
    bundle: includedServices
  } = watch();
  const isBundle = Array.isArray(includedServices);
  const hasDiscountError = Boolean(formState.errors.discount);
  const discountedPrice = useMemo(() => getPriceAfterDiscount({
    pricing,
    price,
    minPrice,
    discount
  }), [pricing, price, minPrice, discount]);
  return /*#__PURE__*/_jsxs(Column, {
    "data-testid": ServicePriceEditorPopoverPricingContentTID.Root(),
    children: [/*#__PURE__*/_jsxs(Grid, {
      rowGap: 24,
      children: [/*#__PURE__*/_jsx(GridItem, {
        span: 12,
        children: /*#__PURE__*/_jsx(PricingTextField, {
          isBundle: isBundle,
          testid: ServicePriceEditorPopoverPricingContentTID.PricingSelect(),
          serviceOrigin: serviceOrigin,
          isExistingService: true
        })
      }), pricing === 'unit' && /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(UnitNameTextField, {
          testid: ServicePriceEditorPopoverPricingContentTID.UnitNameTextField()
        })
      }), pricing === 'range' && /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(MinPriceTextField, {
          testid: ServicePriceEditorPopoverPricingContentTID.MinPriceTextField()
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(PriceTextField, {
          testid: ServicePriceEditorPopoverPricingContentTID.PriceTextField(),
          disabled: isBundle
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        span: 6,
        children: /*#__PURE__*/_jsx(DiscountInput, {
          testid: ServicePriceEditorPopoverPricingContentTID.DiscountInput()
        })
      })]
    }), /*#__PURE__*/_jsx(Collapse, {
      in: Boolean(discountedPrice) && !hasDiscountError,
      unmountOnExit: true,
      children: /*#__PURE__*/_jsx(Row, {
        className: styles.priceAfterDiscount,
        "data-testid": ServicePriceEditorPopoverPricingContentTID.PriceAfterDiscount(),
        children: /*#__PURE__*/_jsxs(Typography, {
          as: "span",
          children: ["Price after discount:", ' ', /*#__PURE__*/_jsx(Typography, {
            weight: "normal",
            as: "span",
            children: discountedPrice
          })]
        })
      })
    })]
  });
};
export default ServicePriceEditorPopoverPricingContent;